var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edicion_block"},[_c('h4',[_vm._v(_vm._s(_vm.$t('drags.space')))]),_vm._v(" "),_c('sizePicker',{attrs:{"min":20,"max":100,"interval":10},model:{value:(_vm.valor.size),callback:function ($$v) {_vm.$set(_vm.valor, "size", $$v)},expression:"valor.size"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }